var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleClose()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("close")
                      ])
                    ],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          Baja Cobranza " +
                        _vm._s(_vm.data.nombre_baja_cobranza) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { sm12: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "" } },
                                          [
                                            _c(
                                              "v-toolbar",
                                              [
                                                _c(
                                                  "v-tabs",
                                                  {
                                                    staticClass:
                                                      "bajas_cobranza_ver_detalle",
                                                    attrs: { centered: "" },
                                                    model: {
                                                      value: _vm.tabs,
                                                      callback: function($$v) {
                                                        _vm.tabs = $$v
                                                      },
                                                      expression: "tabs"
                                                    }
                                                  },
                                                  [
                                                    _c("v-tabs-slider", {
                                                      attrs: { color: "yellow" }
                                                    }),
                                                    _c("v-tab", [
                                                      _vm._v(
                                                        "\n                            Baja Cobranza\n                          "
                                                      )
                                                    ]),
                                                    _c("v-tab", [
                                                      _vm._v(
                                                        "\n                            Dispositivos\n                          "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-tabs-items",
                                          {
                                            model: {
                                              value: _vm.tabs,
                                              callback: function($$v) {
                                                _vm.tabs = $$v
                                              },
                                              expression: "tabs"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-tab-item",
                                              [
                                                _c("TabGeneral", {
                                                  attrs: { data: _vm.data }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-tab-item",
                                              [
                                                _c("TabDispositivos", {
                                                  attrs: { id: _vm.data.id }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("br")
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }